import {Component, Input, OnChanges, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {WissalstoreService} from "../../../Services/wissalstore.service";
import {Router} from "@angular/router";
import {ProductConfiguration} from "../../../Models/product-configuration";
import {auditTime, distinctUntilChanged} from "rxjs/operators";
import {Response} from "../../../Models/response";
import {Page} from "../../../Models/page";

@Component({
    selector: 'app-search-filter',
    templateUrl: './search-filter.component.html',
    styleUrls: ['./search-filter.component.scss'],
    standalone: false
})
export class SearchFilterComponent implements OnInit, OnChanges {

  response?: Response<Page<ProductConfiguration>>  ;

  @Input() configurations? : ProductConfiguration[] ;

  searchBarForm?: FormGroup;
  searchResults: ProductConfiguration[] = [];
  searchFormFocused = false;

  constructor(private fb: FormBuilder, private wissalstoreService: WissalstoreService,private router: Router) { }

  ngOnInit(): void {
    this.searchBarForm = this.fb.group({
      query: ['', Validators.required],

    });
    this.searchBarForm.valueChanges.pipe(auditTime(300), distinctUntilChanged()).subscribe(res => {
        if (res) {
          this.configurations = this.wissalstoreService.searchedPorducts;

          return  this.searchResults = this.configurations.filter( (p: ProductConfiguration) => { return p.name?.toLowerCase().includes(res.query?.toLowerCase()) });

        } else {
          this.searchResults = [];
        }
      }
    );

  }

  onSearch() {

    //search on input enter click
    if (this.searchBarForm?.value.query != '' && this.searchBarForm?.value.query.length >= 2 && this.searchResults.length > 0) {
      switch (this.searchResults.map(value => value.name).includes(this.searchBarForm?.value.query)) {
        case true:
          let selectedProductConfiguration = this.searchResults.find(conf => conf.name === this.searchBarForm?.value.query);
          this.router.navigateByUrl('/products/' + selectedProductConfiguration?.productName?.replace(/[() | /]/g, '') + '/' + selectedProductConfiguration?.productId + '/' + selectedProductConfiguration?.id);
          break;
        default:
          this.router.navigateByUrl('/products/' + this.searchResults[0].productName!.replace(/[() | /]/g, '') + '/' + this.searchResults[0].productId + '/' + this.searchResults[0].id);
          break;
      }
    }

    /*

    if (this.searchBarForm.value.query != '') {

      this.router.navigate(['/products'], {
        queryParams: {
          query: this.searchBarForm.value.query.trim(),
          category: this.searchBarForm.value.category,
        }
      });
    }

     */

    this.searchBarForm?.reset();
    this.hideSideNavFilter();
  }

  ngOnChanges() {
    this.searchResults=this.configurations!
    this.searchBarForm?.get('query')?.setValue('');
  }

  hideSideNavFilter(){
    this.wissalstoreService.sideNavOpen = false;
  }
}
